import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { CustomPropertyAttributeValidation } from 'uplisting-frontend/validations';

export default class CustomPropertyAttributeRepositoryService extends BaseRepositoryService<
  ModelRegistry['custom-property-attribute']
> {
  recordName = 'custom-property-attribute';
  implementMethods = [
    'findAll',
    'buildChangeset',
    'createRecord',
    'unloadAll',
    'peekAll',
  ];

  validation = CustomPropertyAttributeValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/custom-property-attribute': CustomPropertyAttributeRepositoryService;
  }
}
